<template>
  <div class="inventory">
    <!-- 列表搜索 -->
    <div class="search">
      <el-form ref="searchForm" :model="searchForm">
        <el-form-item label="仓库名称：" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.warehouseId"
            placeholder="请选择仓库"
            @change="changeSearchWarehouse"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="项目名称："
          prop="projectId"
        >
          <el-select
            class="white"
            v-model="searchForm.projectId"
            placeholder="请选择项目"
            @change="changeSearchProject"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="date" class="customer-form">
          <el-date-picker
            v-model="searchForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" class="btn-blue" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="title-container">
      <p class="title">盘点结果列表</p>
      <div class="entry" @click="openEntry">
        <span class="entry-img"></span>
        <span>录入</span>
      </div>
    </div>

    <!-- 盘点列表 -->
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
        <el-table-column label="库存区">
          <el-table-column
            prop="stockInventorySurplus"
            label="盘盈"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="stockInventoryLoss"
            label="盘亏"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="拣选区">
          <el-table-column
            prop="pickingInventorySurplus"
            label="盘盈"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="pickingInventoryLoss"
            label="盘亏"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="stockDifference"
          label="库存总差异"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column
          prop="stockDifference"
          label="附件"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column> -->
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 录入 -->
    <el-drawer
      title="录入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="entryForm" :model="entryForm" :rules="rules">
          <div class="tips">
            <img class="sign-blue" src="../../../../assets/images/sigh/sigh-blue.png">
            <span class="tips-content">录入盘点结果，库存差异实时记录</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <p class="sub-title">基本信息</p>
          <el-form-item label="仓库" prop="warehouseId">
            <el-select 
              class="white"
              clearable
              v-model="entryForm.warehouseId"
              placeholder="请选择仓库"
              @change="changeEntryFormWarehouse"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="white"
              v-model="entryForm.projectId"
              placeholder="请选择项目"
              @change="changeEntryFormProject"
            >
              <el-option
                v-for="item in entryFormProjectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="date" class="upload-container">
            <el-date-picker
              v-model="entryForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="上传附件" class="upload-container">
            <el-input
              v-if="!uploadFileName"
              v-model="uploadFileName"
              placeholder="请上传文件"
              disabled
            >
              <template slot="suffix">
                <el-upload
                  v-loading.fullscreen.lock="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :before-upload="uploadGoodsInfoExcel"
                >
                  <img
                    class="upload-img"
                    src="~assets/images/home/upload.png"
                  />
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img
                @click="clearUploadFileName"
                src="~assets/images/close.png"
              />
            </div>
          </el-form-item> -->
          <p class="sub-title">区域</p>
          <div class="row">
            <!-- 库存区 -->
            <img class="stock-img" src="~assets/images/product/stock.png">
            <div class="helf">
              <el-form-item label="盘盈" prop="stockInventorySurplus">
                <el-input
                  v-model="entryForm.stockInventorySurplus"
                  placeholder="请输入"
                  @input="stockInventorySurplusInput(entryForm.stockInventorySurplus)"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="盘亏" prop="stockInventoryLoss">
                <el-input
                  v-model="entryForm.stockInventoryLoss"
                  placeholder="请输入"
                  clearable
                  @input="stockInventoryLossInput(entryForm.stockInventoryLoss)"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <!-- 拣选区 -->
            <img class="stock-img" src="~assets/images/product/picking.png">
            <div class="helf">
              <el-form-item label="盘盈" prop="pickingInventorySurplus">
                <el-input
                  v-model="entryForm.pickingInventorySurplus"
                  placeholder="请输入"
                  clearable
                  @input="pickingInventorySurplusInput(entryForm.pickingInventorySurplus)"
                ></el-input>
              </el-form-item>
              <el-form-item label="盘亏" prop="pickingInventoryLoss">
                <el-input
                  v-model="entryForm.pickingInventoryLoss"
                  placeholder="请输入"
                  clearable
                  @input="pickingInventoryLossInput(entryForm.pickingInventoryLoss)"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Inventory from "models/data-entry/inventory";
import ChargeRegister from "models/charge-register";
import PaginationTpl from "components/base/PaginationTpl";
import warehouseMixins from "@/common/mixins/warehouse.js"
import { getAllInteger } from "common/js/util";
export default {
  mixins: [warehouseMixins],
  components: {
    PaginationTpl
  },

  data() {
    return {
      searchForm: {
        warehouseId: '',
        projectId: '',
        customerId: '',
        date: ''
      },
      projectList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库名称', prop: 'warehouseName', width: ''},
        {label: '货主名称', prop: 'customerName', width: ''},
        {label: '项目名称', prop: 'projectName', width: ''},
      ],

      drawer: false,
      // 录入项目列表
      entryFormProjectList: [],
      entryForm: {
        warehouseId: '',
        date: '',
        customerId: null,
        // formData: null,
        projectId: null,
        // 库存区盘盈
        stockInventorySurplus: null,
        // 库存区盘亏
        stockInventoryLoss: null,
        // 拣选区盘盈
        pickingInventorySurplus: null,
        // 拣选区盘亏
        pickingInventoryLoss: null,
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
      },
      // loading: false,
      // uploadFileName: "",
    }
  },

  created() {
    this.initList()
    this.initWarehouse()
  },

  methods: {
    /** 
     * @desc 盘点列表
    */
    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let customerId = this.searchForm.customerId
      let projectId = this.searchForm.projectId
      let reportDate = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        customerId,
        projectId,
        reportDate
      }

      Inventory.getInventoryList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.reportDate
            obj.warehouseName = i.warehouseName
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.stockInventorySurplus = i.stockAreaSurplus
            obj.stockInventoryLoss = i.stockAreaLoss
            obj.pickingInventorySurplus = i.pickingAreaSurplus
            obj.pickingInventoryLoss = i.pickingAreaLoss
            obj.stockDifference = i.variance
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 获取项目名称
    */
    initGetProjectList(type) {
      let warehouseId
      if (type === 'noEntry') {
        warehouseId = this.searchForm.warehouseId
      } else {
        warehouseId = this.entryForm.warehouseId
      }
      ChargeRegister.getProjectList(warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.customerId = value.customerId;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          if (type === 'noEntry') {
            this.projectList = arr;
            this.searchForm.projectId = arr.length > 0 ? arr[0].id : '';
            this.searchForm.customerId = arr.length > 0 ? arr[0].customerId : '';
          } else {
            this.entryFormProjectList = arr;
            this.entryForm.projectId = arr.length > 0 ? arr[0].id : '';
            this.entryForm.customerId = arr.length > 0 ? arr[0].customerId : '';
          }
        }
      });
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.searchForm.customerId = ''
      this.$refs[formName].resetFields();
    },

    changeSearchWarehouse() {
      this.initGetProjectList('noEntry')
    },

    /** 
     * @desc 选择项目
    */
    changeSearchProject() {
      let obj = this.projectList.find(item => { return item.id == this.searchForm.projectId }) 
      this.searchForm.customerId = obj.customerId
    },

    /** 
     * @desc 开启录入
    */
    openEntry() {
      this.drawer = true
    },
    
    handleCloseDrawer() {
      this.$refs['entryForm'].resetFields();
      this.entryFormProjectList = []
      this.entryForm.formData = null;
      this.drawer = false
    },

    changeEntryFormWarehouse() {
      this.initGetProjectList('entry')
    },

    changeEntryFormProject() {
      let obj = this.entryFormProjectList.find(item => { return item.id == this.entryForm.projectId }) 
      this.entryForm.customerId = obj.customerId
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let reportDate = this.entryForm.date
          let customerId = this.entryForm.customerId
          let projectId = this.entryForm.projectId
          let stockAreaSurplus = this.entryForm.stockInventorySurplus
          let stockAreaLoss = this.entryForm.stockInventoryLoss
          let pickingAreaSurplus = this.entryForm.pickingInventorySurplus
          let pickingAreaLoss = this.entryForm.pickingInventoryLoss
          // let formData = this.entryForm.formData;
          let data = {
            warehouseId,
            reportDate,
            customerId,
            projectId,
            stockAreaSurplus,
            stockAreaLoss,
            pickingAreaSurplus,
            pickingAreaLoss,
          }
          Inventory.postEntryInventory(data).then(res => {
            if (res.success) {
              this.initList()
              this.handleCloseDrawer()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    stockInventorySurplusInput(v) {
      this.entryForm.stockInventorySurplus = getAllInteger(v);
    },

    stockInventoryLossInput(v) {
      this.entryForm.stockInventoryLoss = getAllInteger(v);
    },

    pickingInventorySurplusInput(v) {
      this.entryForm.pickingInventorySurplus = getAllInteger(v);
    },

    pickingInventoryLossInput(v) {
      this.entryForm.pickingInventoryLoss = getAllInteger(v);
    },

    // uploadGoodsInfoExcel(file) {
    //   var formData = new FormData();
    //   formData.append("file", file);
    //   this.entryForm.formData = formData;
    //   this.uploadFileName = file.name;
    //   return false;
    // },

    /**
     * @desc 删除上传文件
     */
    // clearUploadFileName() {
    //   this.uploadFileName = "";
    //   let formData = this.entryForm.formData;
    //   if (formData.get("file")) {
    //     formData.delete("file");
    //     this.entryForm.formData = null
    //   }
    // },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/inventory.scss';
</style>
